import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import history from './history';
import { isAuthenticated } from './auth';
import {
  verifyIfUserIsLogged,
  fillUserRegisterFromLoggedUser
} from '../actions/AuthActions';
import {
  ListNegotiation,
  Home,
  Apportionment,
  AddApportionment,
  AddNegotiation,
  Comprehensiveness,
  DetailNegotiation,
  CommercialPlanList
} from '../screens';
import Loader from '../components/Loader';

class Routes extends Component {
  unlisten = null;

  state = {
    reduxLoaded: false
  };

  componentDidMount = () => {
    this.fillReduxFromStorage();
  };

  fillReduxFromStorage = () => {
    this.props.verifyIfUserIsLogged();
    console.log(this.props.verifyIfUserIsLogged())
    this.setState({ reduxLoaded: true });
  };

  render = () =>
    this.state.reduxLoaded && this.props.loggedUser.profile ? (
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/signin-oidc" component={Home} />
          <Route
            exact
            path="/planos-comerciais"
            component={CommercialPlanList}
          />
          <Route exact path="/negociacoes" component={ListNegotiation} />
          <Route
            exact
            path="/negociacoes/cadastro"
            component={AddNegotiation}
          />
          <Route
            exact
            path="/negociacoes/cadastro/abrangencia"
            component={Comprehensiveness}
          />
          <Route
            exact
            path="/negociacoes/detalhe"
            component={DetailNegotiation}
          />
         
        </Switch>
      </ConnectedRouter>
    ) : (
      <div className="text text-center">
        Aguarde... estamos buscando seus dados de acesso.
      </div>
    );
}

const mapStateToProps = ({ auth, app }) => {
  const { loggedUser } = auth;
  return {
    loggedUser,
    ...app
  };
};

export default connect(
  mapStateToProps,
  {
    verifyIfUserIsLogged,
    fillUserRegisterFromLoggedUser
  }
)(Routes);
